import { render, staticRenderFns } from "./sidenav.pug?vue&type=template&id=acbe6aee&lang=pug&"
import script from "./sidenav.js?vue&type=script&lang=js&"
export * from "./sidenav.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/macmaum1/Desktop/GARAJE/mavalue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acbe6aee')) {
      api.createRecord('acbe6aee', component.options)
    } else {
      api.reload('acbe6aee', component.options)
    }
    module.hot.accept("./sidenav.pug?vue&type=template&id=acbe6aee&lang=pug&", function () {
      api.rerender('acbe6aee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sidenavLayout/components/sidenav/index.vue"
export default component.exports